import { LicenseProduct } from '../models/license-product';
import { isEmpty } from '@tmx/core';
import { AccountSummary } from '@tmx/data-access';

export function assignApplicationIds(
  licenses: LicenseProduct[],
  accountSummary: AccountSummary
) {
  if (isEmpty(licenses)) {
    return licenses;
  }

  const lookup = new Map(
    accountSummary.products.map((product) => [
      product.productId,
      product.applicationId,
    ])
  );
  licenses.forEach((license) => {
    license.applicationId = lookup.get(license.productId) ?? 0;
  });
  return licenses;
}
